
import { useState, useEffect } from 'react';
import { ProfileAveragesService, ProfileAverages } from '@/services/profileAveragesService';

export const useProfileAverages = () => {
  const [averages, setAverages] = useState<ProfileAverages>({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchAverages = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await ProfileAveragesService.getProfileAverages();
        setAverages(data);
      } catch (err) {
        console.error('Error fetching profile averages:', err);
        setError('Failed to load profile averages');
      } finally {
        setLoading(false);
      }
    };

    fetchAverages();
  }, []);

  return { averages, loading, error };
};
